// import React, { useEffect, useState } from "react";
// import {
//     Typography,
//     Button,
//     TextField,
//     Autocomplete,
//     Box,
//     Checkbox,
// } from "@mui/material";
// import { Loader } from "../../components/loader/Loader";
// import {
//     ChannelkartNetworkGet,
//     META_DATA_BATCH_API,
// } from "../../services/networkService";
// import { ConfirmationPopUp } from "../../components/popup/confirmationPopUp";
// import ConfigWrapper from "../salescodeStudio/mandatoryConfigs/optionalFeatures/widget/ConfigWrapper";
// import { updateConfigRequestBody } from "../../services/managePoliciesService";
// import { metaDataBatchPayload } from "../../types/types";
// import { getLob } from "../../services/authenticationService";
// import { validateWithOtp } from "../../stateManagement/actions/validateOtpPopupActions";
// import { manageUpdateAccessObj } from "../manageUpdateAccess/manageUpdateAccessTypes";
// import { getMetaDataConfig, validateMetaDataResponse } from "../../services/uiConfigService";
// import { openPopup } from "../../stateManagement/actions/popupActions";
// import { getConfigFromClientConfig } from "../../services/bannerServices";

// const CashDiscount = () => {
//     const [loading, setLoading] = useState(true);

//     const [divisionOptions, setDivisionOptions] = useState<string[]>([]);
//     const [distributorOptions, setDistributorOptions] = useState<string[]>([]);
//     const [allDistributors, setAllDistributors] = useState<any[]>([]);

//     const [selectedDivisions, setSelectedDivisions] = useState<string[]>([]);
//     const [selectedDistributors, setSelectedDistributors] = useState<string[]>([]);
//     const [discountType, setDiscountType] = useState<"markUp" | "markDown" | null>(null);

//     const [pendingDivisions, setPendingDivisions] = useState<string[]>([]);
//     const [confirmationPopUp, setConfirmationPopUp] = useState(false);

//     const [errors, setErrors] = useState({
//         division: "",
//         distributor: "",
//         discountType: "",
//     });

//     const [savedConfig, setSavedConfig] = useState<any[]>([]);

//     useEffect(() => {
//         const fetchAllData = async () => {
//             try {
//                 setLoading(true);

//                 const divisionRes = await ChannelkartNetworkGet(
//                     "/v1/productAuthCodeMapping?size=10000"
//                 );
//                 const divisions = divisionRes.data.features;

//                 const uniqueProdAuthCodes = Array.from(
//                     new Set(
//                         divisions
//                             ?.map((item: any) => item?.prodAuthCode)
//                             ?.filter((x: any) => typeof x === "string")
//                     )
//                 );
//                 setDivisionOptions(uniqueProdAuthCodes.map(String));

//                 const distributorRes = await ChannelkartNetworkGet(
//                     "/users/mapped/hierarchy?filter=activeStatus%3Aactive%20and%20designation%5Bin%5D%3A%5Bsupplier%5D&size=10000"
//                 );
//                 setAllDistributors(distributorRes.data.features);

//                 const configName = "cash_discount_configuration";
//                 const clientConfig = await getMetaDataConfig("clientconfig");
//                 const configResp = getConfigFromClientConfig(clientConfig, configName);
//                 setSavedConfig(configResp || []);

//             } catch (error) {
//                 console.error(error);
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchAllData();
//     }, []);

//     useEffect(() => {
//         if (selectedDivisions.length === 0) {
//             setDistributorOptions([]);
//             return;
//         }

//         const filtered = allDistributors
//             .filter((dist) => {
//                 if (!dist.prodauthcode) return false;
//                 const codes = dist.prodauthcode.split(",").map((c: any) => c.trim());
//                 return codes.some((code: any) => selectedDivisions.includes(code));
//             })
//             .map((dist) => dist.loginId);

//         setDistributorOptions(Array.from(new Set(filtered)));
//         setSelectedDistributors([]);

//     }, [selectedDivisions, allDistributors]);

//     const validateForm = () => {
//         let hasError = false;

//         const newErrors = {
//             division: "",
//             distributor: "",
//             discountType: "",
//         };

//         if (selectedDivisions.length === 0) {
//             newErrors.division = "Division selection is required.";
//             hasError = true;
//         }
//         if (selectedDistributors.length === 0) {
//             newErrors.distributor = "Distributor selection is required.";
//             hasError = true;
//         }
//         if (!discountType) {
//             newErrors.discountType = "Please select Mark-Up or Mark-Down.";
//             hasError = true;
//         }

//         setErrors(newErrors);
//         return !hasError;
//     };

//     const handleSave = async () => {
//         if (!validateForm()) return;

//         try {
//             const newEntries = selectedDivisions.flatMap((division) =>
//                 selectedDistributors.map((distributor) => ({
//                     division,
//                     distributor,
//                     discountType,
//                 }))
//             );

//             const merged = [...savedConfig, ...newEntries];

//             const uniqueMerged = Array.from(
//                 new Map(
//                     merged.map(item => [
//                         `${item.division}-${item.distributor}-${item.discountType}`,
//                         item
//                     ])
//                 ).values()
//             );

//             const cashDiscountPayload: updateConfigRequestBody = {
//                 domainName: "clientconfig",
//                 domainType: "cash_discount_configuration",
//                 domainValues: uniqueMerged,
//                 lob: getLob(),
//             };

//             const finalMetaDataPayload: metaDataBatchPayload = {
//                 features: [cashDiscountPayload],
//             };

//             validateWithOtp(
//                 (verifiedUser?: manageUpdateAccessObj, verifyResponse?: any) => {
//                     try {
//                         if (verifyResponse.status >= 200 && verifyResponse.status < 300) {
//                             const validationObj = validateMetaDataResponse(
//                                 verifyResponse?.data?.features
//                             );
//                             if (validationObj.success) {
//                                 openPopup("Success", "Config Updated Successfully");
//                                 setSelectedDivisions([]);
//                                 setSelectedDistributors([]);
//                                 setDiscountType(null);
//                                 setPendingDivisions([]);
//                                 setErrors({
//                                     division: "",
//                                     distributor: "",
//                                     discountType: "",
//                                 });
//                             } else {
//                                 openPopup("Error", validationObj.message);
//                             }
//                         } else {
//                             throw new Error();
//                         }
//                     } catch (error) {
//                         openPopup("Error", "Something went wrong");
//                     }
//                 },
//                 undefined,
//                 "all",
//                 META_DATA_BATCH_API,
//                 finalMetaDataPayload,
//                 "PUT"
//             );
//         } catch (error) {
//             openPopup("Error", "Something went wrong");
//             setLoading(false);
//         }
//     };

//     if (loading) return <Loader />;

//     return (
//         <div className="config-container-left" style={{ marginTop: "0", padding: "30px" }}>
//             <div className="config-heading" style={{ height: "auto", width: "100%" }}>
//                 <div>
//                     <Typography sx={{ fontSize: { xs: "1rem", md: "1.2rem", xl: "2.8rem" }, color: "#227C9D" }}>
//                         <span style={{ color: "#00C6B1", fontWeight: "bold" }}>Cash Discount</span> CONFIGURATION
//                     </Typography>
//                     <Typography style={{ fontSize: "clamp(0.4rem, 0.8vw + 0.1rem, 1.8rem)" }}>
//                         The configuration centralizes key details, crucial for the portal’s framework and deployment.
//                     </Typography>
//                 </div>
//             </div>

//             <div className="config-main-logic-container">
//                 <div className="config-main" style={{ padding: "20px" }}>
//                     <ConfigWrapper heading="" customStyles={{ marginTop: "0rem", fontSize: "20px" }}>
//                         <Box display="flex" flexDirection="column" gap={2}>

//                             <Box display="flex" flexDirection="column" gap={1}>
//                                 <Typography color="#606060">
//                                     Please select the division<span style={{ color: "red" }}>*</span>
//                                 </Typography>

//                                 <Autocomplete
//                                     multiple
//                                     limitTags={5}
//                                     disableCloseOnSelect
//                                     options={divisionOptions.length > 0 ? ["Select All", ...divisionOptions] : []}
//                                     value={selectedDivisions}
//                                     onChange={(event, newValue) => {
//                                         let updatedDivisions =
//                                             newValue.includes("Select All")
//                                                 ? selectedDivisions.length === divisionOptions.length
//                                                     ? []
//                                                     : divisionOptions
//                                                 : newValue.filter((v) => v !== "Select All");

//                                         if (selectedDistributors.length > 0) {
//                                             setPendingDivisions(updatedDivisions);
//                                             setConfirmationPopUp(true);
//                                         } else {
//                                             setSelectedDivisions(updatedDivisions);
//                                         }
//                                     }}
//                                     getOptionLabel={(option) => option}
//                                     renderOption={(props, option) => {
//                                         const { key, ...rest } = props;

//                                         return (
//                                             <li key={key} {...rest}>
//                                                 <Checkbox
//                                                     style={{ marginRight: 8 }}
//                                                     checked={
//                                                         option === "Select All"
//                                                             ? selectedDivisions.length === divisionOptions.length
//                                                             : selectedDivisions.includes(option)
//                                                     }
//                                                 />
//                                                 {option}
//                                             </li>
//                                         );
//                                     }}

//                                     renderInput={(params) => (
//                                         <TextField
//                                             {...params}
//                                             placeholder="Select Division"
//                                             size="small"
//                                             error={Boolean(errors.division)}
//                                             helperText={errors.division}
//                                         />
//                                     )}
//                                     sx={{ width: "320px" }}
//                                 />
//                             </Box>

//                             <Box display="flex" flexDirection="column" gap={1}>
//                                 <Typography color="#606060">
//                                     Please select the distributor<span style={{ color: "red" }}>*</span>
//                                 </Typography>

//                                 <Autocomplete
//                                     multiple
//                                     limitTags={5}
//                                     disableCloseOnSelect
//                                     options={distributorOptions.length > 0 ? ["Select All", ...distributorOptions] : []}
//                                     value={selectedDistributors}
//                                     onChange={(event, newValue) => {
//                                         if (newValue.includes("Select All")) {
//                                             setSelectedDistributors(
//                                                 selectedDistributors.length === distributorOptions.length
//                                                     ? []
//                                                     : distributorOptions
//                                             );
//                                         } else {
//                                             setSelectedDistributors(newValue.filter((v) => v !== "Select All"));
//                                         }
//                                     }}
//                                     getOptionLabel={(option) => option}
//                                     renderOption={(props, option) => {
//                                         const { key, ...rest } = props;

//                                         return (
//                                             <li key={key} {...rest}>
//                                                 <Checkbox
//                                                     style={{ marginRight: 8 }}
//                                                     checked={
//                                                         option === "Select All"
//                                                             ? selectedDistributors.length === distributorOptions.length
//                                                             : selectedDistributors.includes(option)
//                                                     }
//                                                 />
//                                                 {option}
//                                             </li>
//                                         );
//                                     }}
//                                     renderInput={(params) => (
//                                         <TextField
//                                             {...params}
//                                             placeholder="Select Distributor"
//                                             size="small"
//                                             error={Boolean(errors.distributor)}
//                                             helperText={errors.distributor}
//                                         />
//                                     )}
//                                     sx={{ width: "320px" }}
//                                 />
//                             </Box>

//                             <Box display="flex" flexDirection="column" gap={1}>
//                                 <Typography color="#606060">
//                                     Please select type of cash discount to be applied<span style={{ color: "red" }}>*</span>
//                                 </Typography>

//                                 <Box
//                                     display="flex"
//                                     flexDirection="row"
//                                     gap={4}
//                                     sx={{ flexWrap: "nowrap", whiteSpace: "nowrap", alignItems: "center" }}
//                                 >
//                                     <label
//                                         style={{
//                                             display: "flex",
//                                             alignItems: "center",
//                                             gap: "6px",
//                                             whiteSpace: "nowrap",
//                                             fontSize: "1rem" 
//                                         }}
//                                     >
//                                         <input
//                                             type="radio"
//                                             name="discountType"
//                                             checked={discountType === "markUp"}
//                                             onChange={() => setDiscountType("markUp")}
//                                         />
//                                         Mark-Up
//                                     </label>

//                                     <label
//                                         style={{
//                                             display: "flex",
//                                             alignItems: "center",
//                                             gap: "6px",
//                                             whiteSpace: "nowrap",
//                                             fontSize: "1rem" 
//                                         }}
//                                     >
//                                         <input
//                                             type="radio"
//                                             name="discountType"
//                                             checked={discountType === "markDown"}
//                                             onChange={() => setDiscountType("markDown")}
//                                         />
//                                         Mark-Down
//                                     </label>
//                                 </Box>


//                                 {errors.discountType && (
//                                     <Typography color="error" fontSize="0.8rem">
//                                         {errors.discountType}
//                                     </Typography>
//                                 )}
//                             </Box>

//                         </Box>
//                     </ConfigWrapper>
//                 </div>

//                 <div className="config-save-button-container">
//                     <Button
//                         variant="contained"
//                         onClick={handleSave}
//                         sx={{
//                             alignSelf: "flex-end",
//                             marginY: "1rem",
//                             fontSize: "clamp(0.5rem,0.9vw + 0.065rem, 1.6rem)",
//                             gap: "7px",
//                         }}
//                     >
//                         SAVE
//                     </Button>
//                 </div>
//             </div>

//             <ConfirmationPopUp
//                 openConfirmModal={confirmationPopUp}
//                 message="Changing division will clear all selected distributors. Do you want to continue?"
//                 setOpenConfirmModal={() => setConfirmationPopUp(false)}
//                 successMethod={() => {
//                     setSelectedDivisions(pendingDivisions);
//                     setSelectedDistributors([]);
//                     setConfirmationPopUp(false);
//                 }}
//             />
//         </div>
//     );
// };

// export default CashDiscount;

import React, { useEffect, useState } from "react";
import {
    Typography,
    Button,
    TextField,
    Autocomplete,
    Box,
    Checkbox,
} from "@mui/material";
import { Loader } from "../../components/loader/Loader";
import {
    ChannelkartNetworkGet,
    ChannelkartNetworkPost,
} from "../../services/networkService";
import { ConfirmationPopUp } from "../../components/popup/confirmationPopUp";
import ConfigWrapper from "../salescodeStudio/mandatoryConfigs/optionalFeatures/widget/ConfigWrapper";
import { getMetaDataConfig } from "../../services/uiConfigService";
import { openPopup } from "../../stateManagement/actions/popupActions";
import { getConfigFromClientConfig } from "../../services/bannerServices";
import "./cashDiscount.css";

interface DistributorOption {
  id: string;
  name: string;
  label: string;
}


const CashDiscount = () => {
    const [loading, setLoading] = useState(true);

    const [divisionOptions, setDivisionOptions] = useState<string[]>([]);
    const [distributorOptions, setDistributorOptions] = useState<DistributorOption[]>([]);
    const [allDistributors, setAllDistributors] = useState<any[]>([]);

    const [selectedDivisions, setSelectedDivisions] = useState<string[]>([]);
    const [selectedDistributors, setSelectedDistributors] = useState<string[]>([]);
    const [discountType, setDiscountType] = useState<"markUp" | "markDown" | null>(null);

    const [pendingDivisions, setPendingDivisions] = useState<string[]>([]);
    const [confirmationPopUp, setConfirmationPopUp] = useState(false);

    const [errors, setErrors] = useState({
        division: "",
        distributor: "",
        discountType: "",
    });

    const [savedConfig, setSavedConfig] = useState<any[]>([]);

    useEffect(() => {
        const fetchAllData = async () => {
            try {
                setLoading(true);

                const divisionRes = await ChannelkartNetworkGet(
                    "/v1/productAuthCodeMapping?size=10000"
                );
                const divisions = divisionRes.data.features;

                const uniqueProdAuthCodes = Array.from(
                    new Set(
                        divisions
                            ?.map((item: any) => item?.prodAuthCode)
                            ?.filter((x: any) => typeof x === "string")
                    )
                );
                setDivisionOptions(uniqueProdAuthCodes.map(String));

                const distributorRes = await ChannelkartNetworkGet(
                    "/users/mapped/hierarchy?filter=activeStatus%3Aactive%20and%20designation%5Bin%5D%3A%5Bsupplier%5D&size=10000"
                );
                setAllDistributors(distributorRes.data.features);

                const configName = "cash_discount_configuration";
                const clientConfig = await getMetaDataConfig("clientconfig");
                const configResp = getConfigFromClientConfig(clientConfig, configName);
                setSavedConfig(configResp || []);

            } catch (error) {
                console.error(error);
            } finally {
                setLoading(false);
            }
        };

        fetchAllData();
    }, []);

 useEffect(() => {
    if (selectedDivisions.length === 0) {
        setDistributorOptions([]);
        return;
    }

    const filtered = allDistributors
        .filter((dist) => {
            if (!dist.prodauthcode) return false;
            const codes = dist.prodauthcode.split(",").map((c: any) => c.trim());
            return codes.some((code: any) => selectedDivisions.includes(code));
        })
        .map((dist) => ({
            id: dist.loginId,
            name: dist.fullName || dist.name || "Unknown",
            label: `${dist.fullName || dist.name} – ${dist.loginId}`,
        }));

    setDistributorOptions(filtered);
    setSelectedDistributors([]);
}, [selectedDivisions, allDistributors]);

    

    const validateForm = () => {
        let hasError = false;

        const newErrors = {
            division: "",
            distributor: "",
            discountType: "",
        };

        if (selectedDivisions.length === 0) {
            newErrors.division = "Division selection is required.";
            hasError = true;
        }
        if (selectedDistributors.length === 0) {
            newErrors.distributor = "Distributor selection is required.";
            hasError = true;
        }
        if (!discountType) {
            newErrors.discountType = "Please select Mark-Up or Mark-Down.";
            hasError = true;
        }

        setErrors(newErrors);
        return !hasError;
    };

    const handleSave = async () => {
        if (!validateForm()) return;
        try {
        const payload = {
            type: discountType,            
            distributor: selectedDistributors.join(",")  
        };

        const response = await ChannelkartNetworkPost("/v1/metaDataFilter/config/markDiscount", payload);
        if (response.status >= 200 && response.status < 300) {
            openPopup("Success", "Cash discount configuration saved successfully.");
            setSelectedDivisions([]);
            setSelectedDistributors([]);
            setDiscountType(null);
            setErrors({
                division: "",
                distributor: "",
                discountType: "",
            });
        }

    } catch (error) {
        console.error(error);
        openPopup("Error", "Something went wrong during submission.");
    }
    };

    if (loading) return <Loader />;

    return (
        <div className="config-container-left" style={{ marginTop: "0", padding: "30px" }}>
            <div className="config-heading" style={{ height: "auto", width: "100%" }}>
                <div>
                    <Typography sx={{ fontSize: { xs: "1rem", md: "1.2rem", xl: "2.8rem" }, color: "#227C9D" }}>
                        <span style={{ color: "#00C6B1", fontWeight: "bold" }}>Cash Discount</span> CONFIGURATION
                    </Typography>
                    <Typography style={{ fontSize: "clamp(0.4rem, 0.8vw + 0.1rem, 1.8rem)" }}>
                        The configuration centralizes key details, crucial for the portal’s framework and deployment.
                    </Typography>
                </div>
            </div>

            <div className="config-main-logic-container">
                <div className="config-main" style={{ padding: "20px" }}>
                    <ConfigWrapper heading="" customStyles={{ marginTop: "0rem", fontSize: "20px" }}>
                        <Box display="flex" flexDirection="column" gap={2}>

                            <Box display="flex" flexDirection="column" gap={1}>
                                <Typography color="#606060">
                                    Please select the division<span style={{ color: "red" }}>*</span>
                                </Typography>

                                <Autocomplete
                                    multiple
                                    limitTags={5}
                                    disableCloseOnSelect
                                    options={divisionOptions.length > 0 ? ["Select All", ...divisionOptions] : []}
                                    value={selectedDivisions}
                                    onChange={(event, newValue) => {
                                        let updatedDivisions =
                                            newValue.includes("Select All")
                                                ? selectedDivisions.length === divisionOptions.length
                                                    ? []
                                                    : divisionOptions
                                                : newValue.filter((v) => v !== "Select All");

                                        if (selectedDistributors.length > 0) {
                                            setPendingDivisions(updatedDivisions);
                                            setConfirmationPopUp(true);
                                        } else {
                                            setSelectedDivisions(updatedDivisions);
                                        }
                                    }}
                                    getOptionLabel={(option) => option}
                                    renderOption={(props, option) => {
                                        const { key, ...rest } = props;

                                        return (
                                            <li key={key} {...rest}>
                                                <Checkbox
                                                    style={{ marginRight: 8 }}
                                                    checked={
                                                        option === "Select All"
                                                            ? selectedDivisions.length === divisionOptions.length
                                                            : selectedDivisions.includes(option)
                                                    }
                                                />
                                                {option}
                                            </li>
                                        );
                                    }}

                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            placeholder="Select Division"
                                            size="small"
                                            error={Boolean(errors.division)}
                                            helperText={errors.division}
                                        />
                                    )}
                                    sx={{ width: "320px" }}
                                />
                            </Box>

                            <Box display="flex" flexDirection="column" gap={1}>
                                <Typography color="#606060">
                                    Please select the distributor<span style={{ color: "red" }}>*</span>
                                </Typography>

                                <Autocomplete
                                    multiple
                                    limitTags={5}
                                    disableCloseOnSelect
                                    options={distributorOptions.length > 0 ? [{ label: "Select All", id: "ALL" }, ...distributorOptions] : []}
                                    value={distributorOptions.filter((opt) => selectedDistributors.includes(opt.id))}
                                    getOptionLabel={(option) => option.label}
                                    onChange={(event, newValue) => {
                                        if (newValue.some((v) => v.id === "ALL")) {
                                            if (selectedDistributors.length === distributorOptions.length) {
                                                setSelectedDistributors([]);
                                            } else {
                                                setSelectedDistributors(distributorOptions.map((d) => d.id));
                                            }
                                        } else {
                                            setSelectedDistributors(newValue.map((v) => v.id));
                                        }
                                    }}
                                    renderOption={(props, option) => {
                                        const { key, ...rest } = props;

                                        return (
                                            <li key={key} {...rest}>
                                                <Checkbox
                                                    style={{ marginRight: 8 }}
                                                    checked={
                                                        option.id === "ALL"
                                                            ? selectedDistributors.length === distributorOptions.length
                                                            : selectedDistributors.includes(option.id)
                                                    }
                                                />
                                                {option.label}
                                            </li>
                                        );
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            placeholder="Select Distributor"
                                            size="small"
                                            error={Boolean(errors.distributor)}
                                            helperText={errors.distributor}
                                        />
                                    )}
                                    sx={{ width: "320px" }}
                                />

                            </Box>

                            <Box display="flex" flexDirection="column" gap={1}>
                                <Typography color="#606060">
                                    Please select type of cash discount to be applied<span style={{ color: "red" }}>*</span>
                                </Typography>

                                <Box
                                    display="flex"
                                    flexDirection="row"
                                    gap={4}
                                    sx={{ flexWrap: "nowrap", whiteSpace: "nowrap", alignItems: "center" }}
                                >
                                    <label
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "6px",
                                            whiteSpace: "nowrap",
                                            fontSize: "1rem" 
                                        }}
                                    >
                                        <input
                                            type="radio"
                                            className="radio-input-cash"
                                            name="discountType"
                                            checked={discountType === "markUp"}
                                            onChange={() => setDiscountType("markUp")}
                                        />
                                        Mark-Up
                                    </label>

                                    <label
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "6px",
                                            whiteSpace: "nowrap",
                                            fontSize: "1rem" 
                                        }}
                                    >
                                        <input
                                            type="radio"
                                            className="radio-input-cash"
                                            name="discountType"
                                            checked={discountType === "markDown"}
                                            onChange={() => setDiscountType("markDown")}
                                        />
                                        Mark-Down
                                    </label>
                                </Box>


                                {errors.discountType && (
                                    <Typography color="error" fontSize="0.65rem">
                                        {errors.discountType}
                                    </Typography>
                                )}
                            </Box>

                        </Box>
                    </ConfigWrapper>
                </div>

                <div className="config-save-button-container">
                    <Button
                        variant="contained"
                        onClick={handleSave}
                        sx={{
                            alignSelf: "flex-end",
                            marginY: "1rem",
                            fontSize: "clamp(0.5rem,0.9vw + 0.065rem, 1.6rem)",
                            gap: "7px",
                        }}
                    >
                        SAVE
                    </Button>
                </div>
            </div>

            <ConfirmationPopUp
                openConfirmModal={confirmationPopUp}
                message="Changing division will clear all selected distributors. Do you want to continue?"
                setOpenConfirmModal={() => setConfirmationPopUp(false)}
                successMethod={() => {
                    setSelectedDivisions(pendingDivisions);
                    setSelectedDistributors([]);
                    setConfirmationPopUp(false);
                }}
            />
        </div>
    );
};

export default CashDiscount;
